<div [formGroup]="form">
  <div class="section">Zuteilung</div>
  <div class="grid">

    <div class="md:col-3">
      <label class="label" for="ownerTenant">Kunde</label>
      <wr-tenant-select
        id="ownerTenant"
        [tenantType]="TenantTypeEnum.External"
        [initialTenant]="valueSignal()?.ownerTenant"
        formControlName="ownerTenantId">
      </wr-tenant-select>
      @if (hasError('ownerTenantId')) {
        <div class="error">Kunde ist erforderlich!</div>
      }
    </div>

    @if (showTeamRegion()) {
      <div class="md:col-3">
        <label class="label" for="region">Bereich</label>
        <input id="region" type="text" fullWidth nbInput formControlName="region" readonly>
      </div>

      <div class="md:col-3">
        <label class="label" for="team">Team</label>
        <input id="team" type="text" fullWidth nbInput formControlName="team" readonly>
      </div>
    }

    <div class="md:col-3">
      <div class="propertyManagerGroup">
        <label class="label" for="propertyManager">Hausverwalter</label>
        <nb-form-field class="propertyManagerContent">

          <input id="propertyManager"
                 fullWidth
                 type="text"
                 nbInput
                 [value]="getPropertyManagerName()"
                 [placeholder]="'Nicht zugewiesen'"
                 [disabled]="form.disabled"
                 readonly> @if (!form.disabled) {
          <button nbSuffix nbButton type="button"
                  status="primary"
                  ghost
                  nbTooltip="Hausverwalter auswählen"
                  (click)="openPropertyManagerDialog()">
            <nb-icon pack="eva" icon="edit-outline"></nb-icon>
          </button>
        }
        </nb-form-field>

        @if (!getPropertyManagerName()) {
          <small class="hint">Noch kein Hausverwalter zugeordnet.</small>
        }
      </div>
    </div>

    <div class="md:col-3">
      <label class="label" for="owner">Eigentümer</label>
      <wr-building-owner-select id="owner" formControlName="owner"></wr-building-owner-select>
    </div>

    <div class="md:col-3">
      <label class="label" for="propertyCaretaker">Hausbetreuer</label>
      <input id="propertyCaretaker" fullWidth type="text" nbInput formControlName="propertyCaretaker">
    </div>

    <div class="md:col-3">
      <label class="label" for="assistant">Assistenz</label>
      <input id="assistant" type="text" fullWidth nbInput formControlName="assistant">
    </div>

  </div>
</div>
